function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import vent from 'elements/vent';
export var tabList = new (/*#__PURE__*/function () {
  function TabList() {
    _classCallCheck(this, TabList);
    // vent.on('APP:READY', (_) => {
    //   this.init();
    // });
    this.init();
  }
  return _createClass(TabList, [{
    key: "init",
    value: function init() {
      document.addEventDelegate('click', this.onChangeTab.bind(this), '[role="tab"]');
      document.addEventDelegate('click', this.onChangeTab.bind(this), '[data-change-tab]');
      document.addEventDelegate('keydown', this.onKeyTablist.bind(this), '[role="tab"]');
      document.addEventDelegate('toggle', this.onToggleDetails.bind(this), 'details');
      // document.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', this.onToggleDetails));
    }
  }, {
    key: "onToggleDetails",
    value: function onToggleDetails(e) {
      var input = document.querySelector('input#input-' + e.target.id);
      if (input) {
        input.value = e.target.open ? 1 : 0;
      }
    }
  }, {
    key: "onChangeTab",
    value: function onChangeTab(e) {
      var tab = e.target;
      this.setActiveTab(tab.getAttribute('data-tab'), tab.getAttribute('aria-controls') || tab.getAttribute('data-change-tab'));
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tabCategory, current) {
      var tabs = document.querySelectorAll('[role="tab"][data-tab="' + tabCategory + '"]');
      var tabPanels = document.querySelectorAll('[role="tabpanel"][data-tab="' + tabCategory + '"]');
      var tabList = tabs[0].closest('[role="tablist"]');
      var input = document.querySelector('input#input-' + tabList.id);
      tabs.forEach(function (t, idx) {
        t.setAttribute('aria-selected', false);
        if (t.getAttribute('aria-controls') == current) {
          t.setAttribute('aria-selected', true);
          setTimeout(function (_) {
            window.scrollTo({
              top: 200
            });
            // t.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'start' });
          }, 20);
          if (input) {
            // input.value = idx;
            input.value = t.getAttribute('data-id');
          }
        }
      });
      tabPanels.forEach(function (panel) {
        panel.setAttribute('hidden', 'hidden');
        if (panel.id == current) {
          panel.removeAttribute('hidden');
          panel.querySelectorAll('.offre-question-card details').forEach(function (card) {
            card.removeAttribute('open');
          });
        }
      });
    }
  }, {
    key: "onKeyTablist",
    value: function onKeyTablist(e) {
      var tab = e.target;
      var tabList = Array.from(document.querySelectorAll('[role="tab"][data-tab="' + tab.getAttribute('data-tab') + '"]'));
      var key = e.key;
      var currentIndex = tabList.indexOf(tab);
      if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 'Home' || key === 'End') {
        e.preventDefault();
      } else {
        return;
      }
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % tabList.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + tabList.length) % tabList.length;
      } else if (key === 'Home') {
        newIndex = 0;
      } else if (key === 'End') {
        newIndex = tabList.length - 1;
      } else if (key === 'Enter' || key === ' ') {
        newIndex = currentIndex;
      }
      var newTab = tabList[newIndex];
      tabList.forEach(function (t) {
        t.setAttribute('tabindex', -1);
      });
      newTab.setAttribute('tabindex', 0);
      newTab.focus();

      // Enter/Space activate (we already activate on focus change above; keep for explicit activation)
      this.setActiveTab(newTab.getAttribute('data-tab'), newTab.getAttribute('aria-controls'));

      // setActiveTab(tabs[newIndex], true);
    }
  }]);
}())();